import React, { useEffect, useState } from "react";
import api from "../api";

// Loads private images with the auth header (img tags cannot send it)
export const SecureImg = ({ src, alt = "", className = "", ...rest }) => {
  const [url, setUrl] = useState("");
  useEffect(() => {
    if (!src) return;
    if (!src.startsWith("/api/")) { setUrl(src); return; }
    let obj = "";
    api.get(src.replace(/^\/api/, ""), { responseType: "blob" })
      .then(r => { obj = URL.createObjectURL(r.data); setUrl(obj); })
      .catch(() => setUrl(""));
    return () => { if (obj) URL.revokeObjectURL(obj); };
  }, [src]);
  if (!url) return <div className={`${className} bg-[var(--cream-100)] animate-pulse`} />;
  return <img src={url} alt={alt} className={className} {...rest} />;
};
